import { SimpleGrid } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
// import styled from "./style.module.css";
import styled from "../tenders/style.module.css";
import Container from "react-bootstrap/Container";
import api from "../../utils/ApiMethod";
import img from "../../assets/images/Download.jpeg";
import Styles from "../../styles/Tender.module.css";
import { Helmet } from "react-helmet-async";
const NoticesCirculars = () => {


  const [data, setData] = useState([]);

  const [search, setSearch] = useState("");

  const handleFetchData = async () => {
    try {
      // const res = await api.fetchData("/noticescirculars");
      //   const res = await api.fetchData("/noticescirculars");
      // const noticeData = await fetch('https://bssa-db.vercel.app/noticescirculars');
      // const noticeData = await fetch('https://bssa-database.vercel.app/noticescircularsENG');
      // const noticeData = await fetch('https://bssa-json-server-vercel-deployment.vercel.app/noticescircularsENG');
      // const noticeData = await fetch('https://bssa-db-vercel.vercel.app/noticescircularsENG');
      const noticeData = await fetch('https://api.biharsports.org/contents/noticescircularsENG');
      const res = await noticeData?.json()

      setData(res);
      // console.log("Fetched data:", data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
   


   
  useEffect(() => {
    handleFetchData();
  }, []);

  console.log("datasss", data)

  return (
    // <div>
    <div className={styled.Container}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Official Notices - Bihar State Sports Authority</title>
        <meta name="description" content="Stay informed with the latest official notices, announcements, and updates from the Bihar State Sports Authority." />
      </Helmet>

      <h1 className="pt-2" style={{ marginBottom: "10px" }}>
        Notice & Circulars
      </h1>
      {/* input field for search the item */}
      <div class={styled.input_group}>
        <div class="form-outline">
          <input
            type="search"
            id="form1"
            class="form-control"
            placeholder="Search for notice & circulars"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>
      <table class="table table-striped ">
        <thead>
          <tr class="table-primary">
            <th className={`${Styles.th}`} scope="col">
              Sr.No.
            </th>
            <th className={`${Styles.head}`} scope="col">
              Title
            </th>
            {/* <th className={`${Styles.head}`} scope="col">
              {" "}
              Date
            </th>
            <th className={`${Styles.head}`} scope="col">
              Last Date
            </th> */}
            <th className={`${Styles.head}`} scope="col">
              Download
            </th>
          </tr>
        </thead>
        <tbody>
          {data &&
            data
              // .filter((item) =>
              //   item.name.toLowerCase().includes(search.toLowerCase())
              // )
              ?.map((item, i) => (
                <tr>
                  <th scope="row">{i + 1}</th>
                  <td
                    className={Styles.table_cell}
                    style={{ textAlign: "left" }}
                  >
                    {item.name}
                  </td>
                  {/* <td
                    className={Styles.table_cell}
                    style={{ textAlign: "left" }}
                  >
                    {item.date}
                  </td>

                  <td
                    className={Styles.table_cell}
                    style={{ textAlign: "left" }}
                  >
                    {item.expiryDate}
                  </td> */}

                  <td
                    className={Styles.table_cell}
                    style={{ textAlign: "left" }}
                  >
                    <a href={item.url} target="_blank">
                      <img className={Styles.table_image} src={img} />
                    </a>
                  </td>
                </tr>
              ))}
        </tbody>
      </table>
    </div>
    // </div>
  );
};

export default NoticesCirculars;
